export default "__VITE_ASSET__D5i3RM2V__"